import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "d-flex flex-column ga-2"
}
const _hoisted_2 = {
  key: 0,
  class: "d-flex align-center flex-wrap ga-2 mb-1"
}
const _hoisted_3 = ["aria-label"]
const _hoisted_4 = {
  key: 2,
  class: "text-caption"
}
const _hoisted_5 = {
  class: "flex-grow-1",
  style: {"min-width":"0"}
}
const _hoisted_6 = { class: "text-subtitle-1 font-weight-bold text-truncate" }
const _hoisted_7 = { class: "text-caption text-medium-emphasis text-truncate" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_avatar = _resolveComponent("v-avatar")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createElementBlock("div", null, [
    (!_ctx.models.length)
      ? (_openBlock(), _createBlock(_component_v_alert, {
          key: 0,
          type: "warning",
          variant: "tonal",
          density: "comfortable",
          icon: "mdi-alert-circle-outline"
        }, {
          default: _withCtx(() => _cache[1] || (_cache[1] = [
            _createTextVNode(" Please configure a model first — add one from "),
            _createElementVNode("strong", null, "New assistant → Add a new brain", -1),
            _createTextVNode(". ")
          ])),
          _: 1,
          __: [1]
        }))
      : (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (_ctx.providerOptions.length > 1)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _cache[2] || (_cache[2] = _createElementVNode("span", { class: "text-caption text-medium-emphasis mr-1" }, "Provider:", -1)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.providerOptions, (p) => {
                  return (_openBlock(), _createBlock(_component_v_checkbox, {
                    key: p.key,
                    modelValue: _ctx.selectedProviders,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedProviders) = $event)),
                    value: p.key,
                    label: p.label,
                    density: "compact",
                    "hide-details": "",
                    class: "provider-check"
                  }, null, 8, ["modelValue", "value", "label"]))
                }), 128))
              ]))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.visibleModels, (m) => {
            return (_openBlock(), _createBlock(_component_v_card, {
              key: m.id,
              variant: _ctx.isSelected(m) ? 'tonal' : 'outlined',
              color: _ctx.isSelected(m) ? 'primary' : undefined,
              rounded: "md",
              class: "pa-3 d-flex align-center ga-4 brain-row",
              onClick: ($event: any) => (_ctx.$emit('update:modelValue', m.id))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_avatar, {
                  size: "40",
                  color: "surface",
                  variant: "tonal",
                  rounded: "md"
                }, {
                  default: _withCtx(() => [
                    (_ctx.isImgIcon(m.providerKey))
                      ? (_openBlock(), _createBlock(_component_v_img, {
                          key: 0,
                          src: (_ctx.iconFor(m.providerKey) as ProviderIcon).src,
                          alt: _ctx.label(m.providerKey)
                        }, null, 8, ["src", "alt"]))
                      : (_ctx.iconFor(m.providerKey))
                        ? (_openBlock(), _createElementBlock("span", {
                            key: 1,
                            class: "brain-logo-mask",
                            style: _normalizeStyle(_ctx.maskStyle(m.providerKey)),
                            role: "img",
                            "aria-label": _ctx.label(m.providerKey)
                          }, null, 12, _hoisted_3))
                        : (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_ctx.initials(m.providerKey)), 1))
                  ]),
                  _: 2
                }, 1024),
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, _toDisplayString(m.name), 1),
                  _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.label(m.providerKey)) + " · " + _toDisplayString(m.model), 1)
                ]),
                _createVNode(_component_v_icon, {
                  icon: _ctx.isSelected(m) ? 'mdi-check-circle' : 'mdi-circle-outline',
                  color: _ctx.isSelected(m) ? 'primary' : 'medium-emphasis'
                }, null, 8, ["icon", "color"])
              ]),
              _: 2
            }, 1032, ["variant", "color", "onClick"]))
          }), 128))
        ]))
  ]))
}